<template>
  <el-dialog title="书单管理" :visible.sync="outerVisible">
    <el-dialog
      width="30%"
      title="添加新书单"
      :visible.sync="innerVisible"
      append-to-body
    >
      <el-input
        v-model="shudan.listName"
        placeholder="请输入书单名称"
      ></el-input>
      <el-input
        type="textarea"
        :rows="2"
        placeholder="请输入书单描述"
        v-model="shudan.description"
        style="margin-top: 10px"
      >
      </el-input>
      <div slot="footer" class="dialog-footer">
        <el-button style="margin-top: 10px" @click="addShudan">确 定</el-button>
        <el-button style="margin-top: 10px" @click="outerVisible = false"
          >取 消</el-button
        >
      </div>
    </el-dialog>
    <div slot="footer" class="dialog-footer">
      <div @click="innerVisible = true" class="addtitle">
        <i class="el-icon-circle-plus-outline"></i>添加新书单
        <span class="tipBox" v-show="readinglist.length===0">(当前您还没有书单，请添加一个私有书单吧！)</span>
      </div>
      <div class="seltitle">
        <span style="line-height: 2">请选择要添加私有书单</span
        ><el-input
          v-model="keyword"
          placeholder="请输入内容"
          @keyup.enter.native="readinglistBySearchF"
        ></el-input>
      </div>
      <div class="listbox">
        <el-checkbox-group class="padding-left left-width" v-model="readids">
          <el-checkbox
            v-for="item in readinglist"
            :label="item.id"
            :key="item.id"
            :value="item.id"
            style="width: 100%; margin-right: 0; height: 26px"
          >
            {{ item.showName }}
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div style="margin-top: 15px">
        <el-button @click="outerVisible = false">取 消</el-button>
        <el-button type="primary" @click="changereadlist">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import eventBus from "@/utils/eventBus.js"
import {
  addShudan,
  readinglistBySearch,
  editreadlist,
  getReadListNew
} from "@/api/api"
export default {
  name: "addReadList",
  data () {
    return {
      keyword: "",
      readids: [],
      outerVisible: false,
      innerVisible: false,
      input: '',
      readinglist: [],//书单
      shudan: {
        listName: '',
        description: '',
        bookIdList: []
      },
      bookids: ''
    }
  },
  mounted () {
    eventBus.$on("doChangeTwoVisible", (val, id) => {
      // console.log(id, 'ids')
      this.doChangeTwoVisible(val)
      this.bookids = id
      this.readinglistBySearchF({})
    })


  },
  methods: {

    changereadlist () {

      if (this.readids.length == 0) {
        return this.$message.warning("请选择书单")
      }

      let tempidstr = JSON.parse(JSON.stringify(this.readids))
      let idstr = tempidstr.join()

      console.log(this.readids[0], tempidstr, 'readids')
      // let param = { listId: this.readids[0], bookIdList: this.bookids }
      editreadlist({ listId: this.readids[0], bookIdList: [this.bookids], isAdd: 1 }).then(
        (d) => {
          console.log(d, 'readids')
          this.outerVisible = false
          if (d.code == 200) {
            this.$bus.$emit('readinglistBySearchF')
            this.$message.success("新增成功")
          } else {
            this.$message.error(d.msg)
            //this.$message.warning("新增失败")
          }
        },

      )

      // let handleFields = [
      //   "categoryIds",
      // ]
      // this.isSearchFilter = false
      // let tempSearchFilter = JSON.parse(JSON.stringify(this.searchFilter))
      // handleFields.map((fields) => {
      //   if (tempSearchFilter[fields]) {
      // tempSearchFilter[fields] = tempSearchFilter[fields].join()
      // }
      // })

    },
    doChangeTwoVisible (val) {
      this.outerVisible = val
    },
    addShudan () {
      addShudan(this.shudan).then(
        (d) => {

          this.innerVisible = false
          if (d.code == 200) {
            this.readinglistBySearchF()
            this.$bus.$emit('readinglistBySearchF')
            this.$message.success("新增成功")
          } else {
            this.$message.warning("新增失败")
          }

        },

      )

    },
    readinglistBySearchF () {

      readinglistBySearch({ pageNum: 1, pageSize: 1000, keyword: this.keyword }).then(
        (d) => {
          this.readinglist = d.userSearchRangeVoList

        },

      )

    },
  }
}
</script>

<style lang="less" scoped>
/deep/.el-dialog__body {
  padding: 0 20px;
}
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #E9B63E;
}
/deep/ .el-checkbox__label{
  color: #2B2B2B;
}
/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #E9B63E;
  border-color: #E9B63E;
}
/deep/.el-checkbox__input .is-focus .el-checkbox__inner,
/deep/.el-checkbox__inner:hover {
  border-color: #E9B63E;
}
.addtitle {
  text-align: left;
  line-height: 4;
  color: #DBB054;
  cursor: pointer;
  .tipBox{
    font-size: 12px;
    color: red;
  }
}
/deep/.el-button--primary:focus,
.el-button--primary:hover,
.el-button--primary {
  background: #DBB054;
  border-color:#DBB054;
}
/deep/.el-button:hover{
  background: #fff;
  border-color:#DBB054;
  color:#DBB054;
}
.listbox {
  text-align: left;
  max-height: 200px;
  overflow-y: auto;
}
.seltitle {
  text-align: left;
}
.el-input {
  text-align: left;
}
.el-input__inner {
  width: 50%;
}
/deep/.el-checkbox {
  line-height: 26px;
}
</style>



// WEBPACK FOOTER //
// src/components/addreadlist.vue